export const endpoint = "https://backend.weddingasia.in"
export const placeholderImage = "http://placehold.it/30x20/a334d2/ffffff/&text=LargeImage"